export default "__VITE_ASSET__CzVYs8EC__"